import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { MainTitle, Text } from "../../components/common/texts";
import MyContainer from "../../components/ui/myContainer/MyContainer";
import { api } from "../../utils/api/api";
import { PublicationEntry, StyledPublications } from "./publications.styles";

const Publications = () => {
  const [publications, setPublications] = useState([]);
  const { t, i18n } = useTranslation("publications");
  const showLoader = useSelector((state) => state.loader.isLoading);
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    api.get("/publications/").then((res) => {
      setPublications(res.data);
    });
  }, []);

  const pickText = (item, englishKey, arabicKey) => {
    if (isArabic) return item[arabicKey] || item[englishKey] || "";
    return item[englishKey] || item[arabicKey] || "";
  };

  return (
    <>
      {!showLoader ? (
        <MyContainer>
          <StyledPublications className="m-0 pt-5 pb-5">
            <Col md={9} lg={8} className="d-flex flex-column gap-4">
              <MainTitle $align="initial">{t("title")}</MainTitle>
              <Text>{t("description")}</Text>

              <div className="d-flex flex-column gap-4 mt-3">
                {publications.map((item) => {
                  const title = pickText(item, "title", "title_ar");
                  const authors = pickText(item, "authors", "authors_ar");
                  const journal = pickText(item, "journal", "journal_ar");

                  return (
                    <PublicationEntry key={item.id}>
                      <div className="meta">
                        {item.date}
                        {journal ? ` • ${journal}` : ""}
                      </div>
                      {item.link ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {title}
                        </a>
                      ) : (
                        <h2>{title}</h2>
                      )}
                      {authors && <p>{authors}</p>}
                      {item.doi && <span>DOI: {item.doi}</span>}
                    </PublicationEntry>
                  );
                })}
              </div>
            </Col>
          </StyledPublications>
        </MyContainer>
      ) : (
        <div style={{ minHeight: "500px" }}></div>
      )}
    </>
  );
};

export default Publications;
